import { StrCtn } from '@/api/connections'
import { firebaseObjectToArray, firebaseObjectWithId } from '@/utils'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'
import { STORES } from 'db'

const STORE_CONNECTION = StrCtn

const state = {
    store: false,
    ...async()
}

const getters = {
    GET_STORE: (state) => firebaseObjectWithId(state.store),
    GET_ASYNC
}

const mutations = {
    SET_STORE(state, payload) {
        state.store = payload
    },
    CLEAR_STORE(state) {
        state.store = false
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================

    // =================================== Read Operations ===================================

    /**
     * FETCH_STORE_BY_ID
     *
     *     Retrieve a store by id. If empty, set false. Binds a firebase connection.
     *
     * @param payload.id {string} - The id of the store to retrieve.
     * @returns {Void}
     */
    async FETCH_STORE_BY_ID({ commit, dispatch }, payload) {
        await dispatch('REMOVE_STORE_REFERENCE')
        commit('REQUEST')
        const parseStore = async (data) => {
            let employees = {}
            await dispatch(
                'usersStore/FETCH_USER_STORE_BY_ID',
                {
                    id: data[STORES.fields.storeOwnerId]
                },
                { root: true }
            )
            await Promise.all(
                firebaseObjectToArray(data[STORES.fields.storeEmployees]).map(async (employee) => {
                    employees[employee.id] = {
                        ...(await dispatch(
                            'usersStore/FETCH_USER_STORE_BY_ID_ONCE',
                            {
                                id: employee.id,
                                shouldReturn: true
                            },
                            { root: true }
                        )),
                        ...employee
                    }
                })
            )
            await dispatch(
                'couriers/FETCH_COURIER_BY_ID',
                {
                    id: data[STORES.fields.courierId]
                },
                { root: true }
            )
            const finalStore = Object.assign({}, { ...data }, { [STORES.fields.storeEmployees]: employees })
            commit('SET_STORE', data ? { ...finalStore, id: payload.id } : false)
        }
        try {
            STORE_CONNECTION.on('value', parseStore)
            STORE_CONNECTION.initValue([payload.id])
            commit('SUCCESS')
        } catch (err) {
            commit('ERROR', err.message)
        }
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_STORE_REFERENCE
     *
     *     Unbind a firebase connection that was set on a store child.
     *
     */
    REMOVE_STORE_REFERENCE({ commit }) {
        commit('CLEAR')
        commit('CLEAR_STORE')
        STORE_CONNECTION.removeAllListeners()
        STORE_CONNECTION.closeValue()
    }
}

export { state, getters, mutations, actions }
